var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.005 3.005 C 3.278 2.732 3.722 2.732 3.995 3.005 L 7 6.01 L 10.005 3.005 C 10.181 2.823 10.441 2.75 10.686 2.814 C 10.931 2.878 11.122 3.069 11.186 3.314 C 11.25 3.559 11.177 3.819 10.995 3.995 L 7.99 7 L 10.995 10.005 C 11.26 10.28 11.256 10.716 10.986 10.986 C 10.716 11.256 10.28 11.26 10.005 10.995 L 7 7.99 L 3.995 10.995 C 3.72 11.26 3.284 11.256 3.014 10.986 C 2.744 10.716 2.74 10.28 3.005 10.005 L 6.01 7 L 3.005 3.995 C 2.732 3.722 2.732 3.278 3.005 3.005 Z",
    fill: "rgb(108, 114, 132)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.db22901becdff543709c324363d9b521.svg";
export { ForwardRef as ReactComponent };